import styled from '@emotion/styled';
import { css } from 'emotion';

export const ContentWrapper = styled.div`
  display: block;
  width: 100%;
  height: 100%;
  padding: 20px 16px;
  text-align: left;
`;

export const uploaderCancelButtonStyle = css`
  width: 112px;
  height: 40px;
  color: #9a201c;
`;

export const IconWrapper = styled.div`
  width: 28px;
  height: 28px;
`;
